// src/utils/monthsUtil.js

/**
 * Returns an array of 12 objects, one per month, with a Mongo-style
 * `tran_date` range spanning from the start to the end of that month.
 *
 * @param {string|number} year – e.g. "2025" or 2025
 * @returns {Array<{ name: string, tran_date: { $gte: string, $lte: string } }>}
 */
export default function monthsUtil(year) {
  const y = String(year);
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  return monthNames.map((name, idx) => {
    const m = String(idx + 1).padStart(2, "0");
    const gte = `${y}-${m}-01T00:00:00.000Z`;

    // get last day of this month
    const lastDayDate = new Date(Number(y), idx + 1, 0).getDate();
    const d = String(lastDayDate).padStart(2, "0");
    const lte = `${y}-${m}-${d}T23:59:59.999Z`;

    return {
      name,
      tran_date: { $gte: gte, $lte: lte },
    };
  });
}
